import React from "react";
import { Popup } from "react-map-gl/maplibre";
import { Box } from "@mui/material";
import ReactivePopupContent from "./ReactivePopupContent";
import { ApiEndpoint } from "../../../types";

// This MapPopup component is a wrapper for the ReactivePopupContent component.
// This is derived from the MapComponent component which is split into its own component for reusability and maintainability

export interface MapPopupData {
  entityId: string | number;
  entityName: string;
  endpoint: ApiEndpoint;
  coordinates: [number, number];
}

interface Props {
  popupData: MapPopupData | null;
  open: boolean;
  onClose: () => void;
}

const MapPopup: React.FC<Props> = ({ popupData, open, onClose }) => {
  if (!open || !popupData) return null;

  return (
    <Popup
      key={`popup-${popupData.entityId}`}
      longitude={popupData.coordinates[0]}
      latitude={popupData.coordinates[1]}
      offset={[0, -16]}
      anchor='bottom' // Force the anchor to always be at the bottom
      closeOnClick={false}
      maxWidth='500px'
      onClose={onClose}
      className='react-popup'
      subpixelPositioning
    >
      <Box
        sx={{
          maxWidth: 480,
          minWidth: 200,
          maxHeight: "80vh",
          overflowY: "auto",
          "& .MuiCard-root": {
            borderRadius: "8px"
          }
        }}
      >
        <ReactivePopupContent
          entityId={popupData.entityId}
          entityName={popupData.entityName}
          endpoint={popupData.endpoint}
          onBack={onClose}
        />
      </Box>
    </Popup>
  );
};

export default React.memo(MapPopup);
